Namespace 'Monitoring.Reports.Campaign'

class Monitoring.Reports.Campaign.ReportView extends Backbone.View
  include @, Monitoring.Reports.Campaign.Utils

  className: 'campaign-report'

  events:
    'click #build': 'build'
    'click #pdf': 'exportPDF'
    'click #print': 'print'
    'click #share': 'share'
    'click #pptx': 'exportPowerPoint'
    'click #individual-post-analysis': 'checkPostCount'

  initialize: (@options = {}) ->
    Highcharts.setOptions({global: {useUTC: false}})
    Keepcon.addPublicAccessTokenToRequests()

    @options.colors = {
      negative: '#FF5722'
      neutral: '#FFE082'
      positive: '#009688'
    }

    @channelPosts = {
      twitter: []
      facebook: []
      instagramMedia: []
    }

    for post in @options.posts
      @channelPosts[post.type].push(post)

    @wordLists = {
      general: []
      twitter: []
      facebook: []
      instagram: []
    }
    @maxPostCount = 30

  render: ->
    @headerView = new Monitoring.Reports.Campaign.HeaderView($.extend({}, @options,{maxPostCount: @maxPostCount}))
    @headerView.render()
    @$el.html(@headerView.el)
    @$('.report-settings').find('.processing-icon').hide()
    if @options.individual_post == "true" then @$('#individual-post-analysis').prop('checked', true)
    if @options.engagement_evolution == "true" then @$('#egmnt-rate-evolution').prop('checked', true)
    if @options.export == "true"
      @$('#build').css('display', 'none')
      @$('#share').css('display', 'none')
      @build()
    @$('#pdf').attr('disabled', true)
    @$('#print').attr('disabled', true)
    return this

  build: =>
    params = @paramsForChildsOfPosts()
    @_disableHeader()
    $.post('/monitoring/reports/campaign/counts', params, @buildSections)
    @eventAggregator.trigger('monitoring:campaign:search')

  buildSections: (data) =>
    return showError data['error'] if data['error']
    @options.date_from_ISO = @_dateFromISO()
    @options.date_to_ISO = @_dateToISO()
    @options.timezone = @headerView._selectedTimeZone()
    @$('section').remove()
    sections = []
    postsRendered = 0
    sections.push @_generalSection data

    if @channelPosts.twitter.length > 0
      sections.push @_twitterCampaignSection()
      sections.push @_twitterPostsSection(postsRendered) if @_individualPostAnalysis()
    postsRendered += @channelPosts.twitter.length

    if @channelPosts.facebook.length > 0
      sections.push @_facebookCampaignSection()
      sections.push @_facebookPostsSection(postsRendered) if @_individualPostAnalysis() and postsRendered < @maxPostCount
    postsRendered += @channelPosts.facebook.length

    if @channelPosts.instagramMedia.length > 0
      sections.push @_instagramCampaignSection()
      sections.push @_instagramPostsSection(postsRendered)  if @_individualPostAnalysis() and postsRendered < @maxPostCount

    @pending = sections.length
    @_renderSection section for section in sections
    @_renderPostsPreviews()
    @$('#pdf').attr('disabled', false)

  _generalSection: (data) ->
    new Monitoring.Reports.Campaign.GroupView(
      $.extend {}, @options,
        title: "Total de contenidos clasificados: #{data['contents'].classified} de #{data['contents'].total}"
        section: 'general'
        channelsCounts: data['channels']
        main: true
        topTags: @topTags()
    )

  _twitterCampaignSection: ->
    new Monitoring.Reports.Campaign.GroupView(
      $.extend {}, @options,
        title: 'Twitter'
        subtitle: I18n.t 'monitoring.dashboard.campaign.campaign_report'
        posts: @channelPosts.twitter
        section: 'twitter'
        icon: true
        separator: 'true'
        topTags: @topTags()
    )

  _twitterPostsSection: (postsRendered) ->
    new Monitoring.Reports.Campaign.PostsView(
      $.extend {}, @options,
        title: 'Twitter'
        subtitle: I18n.t 'monitoring.dashboard.campaign.posts'
        section: 'twitter'
        selected_posts: @channelPosts.twitter
        icon: true
        postsRendered: postsRendered
        maxPostCount: @maxPostCount
    )

  _facebookCampaignSection: ->
    new Monitoring.Reports.Campaign.GroupView(
      $.extend {}, @options,
        title: 'Facebook'
        subtitle: I18n.t 'monitoring.dashboard.campaign.campaign_report'
        posts: @channelPosts.facebook
        section: 'facebook'
        icon: true
        separator: 'true'
        summary: true
        engmt_rate_evolution: @_includeEngagementRateEvolution()
        topTags: @topTags()
    )

  _facebookPostsSection: (postsRendered) ->
    new Monitoring.Reports.Campaign.PostsView(
      $.extend {}, @options,
        title: 'Facebook'
        subtitle: I18n.t('monitoring.dashboard.campaign.posts')
        section: 'facebook'
        selected_posts: @channelPosts.facebook
        icon: true
        postsRendered: postsRendered
        maxPostCount: @maxPostCount
    )

  _instagramCampaignSection: ->
    new Monitoring.Reports.Campaign.GroupView(
      $.extend {}, @options,
        title: 'Instagram'
        subtitle: I18n.t 'monitoring.dashboard.campaign.campaign_report'
        posts: @channelPosts.instagramMedia
        section: 'instagram'
        icon: true
        separator: 'true'
        topTags: @topTags()
    )

  _instagramPostsSection: (postsRendered) ->
    new Monitoring.Reports.Campaign.PostsView(
      $.extend {}, @options,
        title: 'Instagram'
        subtitle: I18n.t('monitoring.dashboard.campaign.posts')
        section: 'instagram'
        selected_posts: @channelPosts.instagramMedia
        icon: true
        postsRendered: postsRendered
        maxPostCount: @maxPostCount
    )

  _renderSection: (section) ->
    section.bind('rendered', @_sectionRendered)
    section.bind('generalSectionRendered', @_generalSectionRendered)
    section.bind('twitterSectionRendered', @_twitterSectionRendered)
    section.bind('facebookSectionRendered', @_facebookSectionRendered)
    section.bind('instagramSectionRendered', @_instagramSectionRendered)
    section.render()
    @$el.append section.el

  exportPDFDeprecated: ->
    @_export('pdf')

  exportPowerPoint: ->
    @_export('pptx')

  print: ->
    $('.campaign-report').css('overflow-y', 'unset')
    @$('.row-fluid').toggleClass('reduced-width')
    @_chartsReflow()
    @$('.row-fluid').toggleClass('reduced-width')
    window.print()
    $('.campaign-report').css('overflow-y', 'auto')
    @_chartsReflow()

  _chartsReflow: ->
    _.each(Highcharts.charts, (chart) =>
      chart.reflow()
    )

  _export: (format) ->
    showNotice('Exporting process started')

    @_disableHeader()

    params = {
      format: format
      sections: []
      type: 'campaign'
      twitter_posts: @channelPosts.twitter # needed to make tweets visible in exported reports
      word_lists: @wordLists
    }
    params.sections.push((this.$('.general-section')[0]).outerHTML)
    params.sections.push((this.$('.facebook-section.any-section')[0]).outerHTML)
    for section in @$('.facebook-content')
      params.sections.push(section.outerHTML)

    $.post('/monitoring/reports/exporter/export', params, (response) =>
      @jobId = response.job_id
      @_askIfCompleted()
    )

  _askIfCompleted: =>
    $.post('/monitoring/reports/exporter/export_finish', {job_id: @jobId}, (response) =>
      if response.status == 'completed'
        showNotice('Downloading')
        window.open(
          response.link,
          '_blank');
        @_enableHeader()

      else if response.status == 'failed'
        showError('Exportation failed. If this error persists, please contact us.')
        @_enableHeader()

      else if response.status != 'not_found'
        setTimeout(@_askIfCompleted, 2000)
    )

  #Code repeated with weekly header_view (however, it might be moved to pure js)
  exportPDF: ->
    @$('#pdf').attr('disabled', true)
    params = @_reportParams()
    swal
      title: 'Export started!'
      type: 'success'
      text: "We will send you an email once it's completed"
      html: true
    $.post('/monitoring/reports/campaign/share', params, (response) =>
      @createPDF(response)
    )

  createPDF: (token_url) =>
    params = {
      token_url: token_url.url,
      format: 'pdf',
      type: "campaign",
      charts_resize: true
    }
    $.post('/monitoring/reports/exporter/export', params, (response) =>
      @waitForDownload(response)
    )

  waitForDownload: (response) =>
    @jobId = response.job_id
    @_askIfCompleted()

  _askIfCompleted : =>
    $.get('/monitoring/reports/exporter/export_finish', {job_id: @jobId}, (response) =>
      if response.status == 'completed'
        @$('#pdf').attr('disabled', false)
      else if response.status != 'not_found' && response.status != 'failed'
        setTimeout(@_askIfCompleted, 2000)
      else
        showError(I18n.t('monitoring.reports.export_fail'))
        @$('#pdf').attr('disabled', false)
    )

  share: ->
    params = @_reportParams()
    $.post('/monitoring/reports/campaign/share', params, (response) =>
      textarea = $('<textarea/>').attr('rows', 3).attr('onclick', 'this.select()').css('width', '400px').html(response.url)
      swal
        title: I18n.t('monitoring.reports.facebook_activity.shared'),
        type: 'success'
        text: $('<div/>').append(textarea).html()
        html: true
    )

  _reportParams: ->
    posts_ids = for post in @options.posts
      post.id
    params = {
      account_id: @options.account_id,
      date_from: @$('#from').val(),
      date_to: @$('#to').val(),
      posts: posts_ids,
      export: true,
      engagement_evolution: @_includeEngagementRateEvolution(),
      individual_post: @_individualPostAnalysis()
    }

  _dateFromISO: ->
    @headerView.getFromDate()

  _dateToISO: ->
    @headerView.getToDate()

  _individualPostAnalysis: ->
    @$('#individual-post-analysis').prop('checked')

  _includeEngagementRateEvolution: ->
    @$('#egmnt-rate-evolution').prop('checked')

  topTags: ->
    5

  _sectionRendered: =>
    @pending -= 1
    @_enableHeader() if @pending == 0

  _generalSectionRendered: (wordLists) =>
    @wordLists.general = wordLists

  _twitterSectionRendered: (wordLists) =>
    @wordLists.twitter = wordLists

  _facebookSectionRendered: (wordLists) =>
    @wordLists.facebook = wordLists

  _instagramSectionRendered: (wordLists) =>
    @wordLists.instagram = wordLists

  _renderPostsPreviews: ->
    twttr.events.bind 'rendered', (event) ->
      $("#" + event.target.id).contents().find(".EmbeddedTweet").css("border-radius", "0px")
      return
    twttr.widgets.load()
    instgrm.Embeds.process()

    @$('.fb-post-container').each (i, e) ->
      FB.XFBML.parse(e)

  _disableHeader: ->
    @$('input.date').attr('disabled', true)
    @$('#individual-post-analysis').attr('disabled', true)
    @$('#max-tags-displayed').attr('disabled', true)
    @$('#egmnt-rate-evolution').attr('disabled', true)
    @$('#build').attr('disabled', true)
    @$('#print').attr('disabled', true)
    @$('.report-settings').find('.processing-icon').show()

  _enableHeader: ->
    @$('#print').removeAttr('disabled')
    if @options.export == "true" then return
    @$('#individual-post-analysis').removeAttr('disabled')
    @$('#max-tags-displayed').removeAttr('disabled')
    @$('#egmnt-rate-evolution').removeAttr('disabled')
    @$('input.date').removeAttr('disabled')
    @$('button').removeAttr('disabled')
    @$('.report-settings').find('.processing-icon').hide()

  checkPostCount: =>
    if @options.posts.length > @maxPostCount
      element = $('#too-many-posts-error')
      if element.is(":visible")
        element.hide()
      else
        element.show()
